export default "__VITE_ASSET__CNCqgWf6__"